import React from 'react'
import './Qualifications.css'

function Qualifications() {
    return (
        <div>
            <section id="resume" class="resume mb-5">
                <div class="container">

                    <div className="header-text-h1">
                        <h1 className='header-text'>Qualifications and Experience</h1>
                    </div>
                    <br />

                    <div class="row justify-content-center mx-lg-5 mx-md-3 ">
                        <div class="col-lg-3 mx-3" data-aos="fade-up" style={{ textAlign: 'left' }}>

                            <h3 class="resume-title">Education</h3>
                            <div class="resume-item">
                                <h4>Computer Engineering</h4>
                                <h5>2020 - 2024</h5>
                                <p><a href="https://ddu.ac.in/"><em>Dharmsinh Desai Institute of Technology, Nadiad(Gujarat)</em></a></p>
                                <p>CGPA - 7.73/10.0</p>
                            </div>
                            <div class="resume-item">
                                <h4>Higher Secondary Education</h4>
                                <h5>2018 - 2020</h5>
                                <p><em>Ramkrishna Vidhya Bhavan, Surat, Gujarat</em></p>
                                <p>98.68 PR</p>
                            </div>
                            <div class="resume-item">
                                <h4>Secondary Education</h4>
                                <h5>2016 - 2018</h5>
                                <p><em>Sadbhavana School, Surat, Gujarat</em></p>
                                <p>98.02 PR</p>
                            </div>
                        </div>

                        {/* <!-- Proffessional Experience --> */}

                        <div class="col-lg-3 mx-3" data-aos="fade-up" data-aos-delay="100" style={{ textAlign: 'left' }}>
                            <h3 class="resume-title">Professional Experience</h3>
                            <div class="resume-item">
                                <h4>Software Engineer</h4>
                                <h5>June 2025 - Present</h5>
                                <p><a href="https://www.linkedin.com/company/amazon/"><em>Amazon</em></a></p>
                                <ul>
                                    <li>Completed JDK migration for a key microservice, ensuring seamless compatibility and improved performance.</li>
                                    <li>Contributing to the migration of a business domain from a legacy system to a modern architecture, enhancing scalability and maintainability.</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>Software Engineer</h4>
                                <h5>Nov. 2023 - May 2025</h5>
                                <p><a href="https://www.crestdata.ai/"><em>Crest Data</em></a></p>
                                <ul>
                                    <li>Contributed to the development of a SaaS application enabling users to migrate alerts, dashboards, and visualizations across different SIEM tools. Developed the alert migration module to fetch, structure, and migrate Splunk alerts to Elastic.</li>
                                    <li>Designed and implemented REST APIs and Components for Migration tool using Python and ReactJS framework.</li>
                                    <li>Implemented automated scripts to generate reports based on the provided information, reducing manual work by 75%.</li>
                                    <li>Developed features and resolved bugs for the Testing Utility using Python, reducing manual testing efforts by 70%</li>
                                    <li>Enhanced performance and efficiency by 40% through refactoring the existing codebase and workflows in back-end development.</li>
                                    <li>Developed Parsers for client products.</li>
                                </ul>
                            </div>
                            {/* <div class="resume-item">
                                <h4>SDE Intern</h4>
                                <h5>Nov. 2023 - Apr. 2024</h5>
                                <p><a href="https://www.crestdata.ai/"><em>Crest Data</em></a></p>
                                <ul>
                                    <li>Trained with Python, FASTAPI, JavaScript and ReactJS.</li>
                                    <li>Developed features and resolved bugs for the Testing Utility using Python, reducing manual testing efforts by 70%.</li>
                                    <li>I developed multiple web pages using React for a client project.</li>
                                </ul>
                            </div> */}
                        </div>

                        {/* <!-- Volunteering & leadership --> */}
                        <div class="col-lg-3 mx-3" data-aos="fade-up" data-aos-delay="100" style={{ textAlign: 'left' }}>
                            <h3 class="resume-title">Volunteering & Leadership</h3>
                            <div class="resume-item">
                                <h4>CP Lead</h4>
                                <h5>Jul. 2023 - Dec. 2024</h5>
                                <p><a href="https://gdsc.community.dev/dharmsinh-desai-university-nadiad/"><em>Google Developer Student Club - DDU</em></a></p>
                                <ul>
                                    <li>Planned and executed coding contests, workshops, and interactive sessions as the CP Lead at GDSC, fostering a collaborative learning environment and enhancing members' problem-solving skills beyond the traditional curriculum.</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>CP Team member</h4>
                                <h5>Jul. 2022 - Jun. 2023</h5>
                                <p><a href="https://gdsc.community.dev/dharmsinh-desai-university-nadiad/"><em>Google Developer Student Club - DDU</em></a></p>
                                <ul>
                                    <li>Active member of the CP team at GDSC, contributing to problem-solving initiatives, contests, and workshops to enhance coding skills and foster a competitive spirit among members.</li>
                                </ul>
                            </div>
                            <div class="resume-item">
                                <h4>Management Lead</h4>
                                <h5>Jul. 2022 - Feb. 2023</h5>
                                <p><a href="https://duhacks.tech/"><em>DUHacks Hackathon</em></a></p>
                                <ul>
                                    <li>Working closely with fellow leads and teams to coordinate and organize key elements of the hackathon, including venue selection, logistical arrangements, budget management, sponsorship acquisition, marketing strategies, and participant registration.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Qualifications